import type { ResultsView } from '~/types'
import { acceptHMRUpdate } from 'pinia'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

// all in one file for now, will be split into multiple files later if necessary
export const useUiStore = defineStore('ui', () => {
  const breakpoints = useBreakpoints(breakpointsTailwind)
  const activeBreakpoints = breakpoints.active()
  const smallViewport = computed(() => !activeBreakpoints.value || ['sm'].includes(activeBreakpoints.value))

  // state
  const showList = ref(false)
  const resultsView = ref<ResultsView>(smallViewport ? 'map' : 'list-map')
  const showResultsAsMapMoves = ref(true)
  const searchAndFilterOptionsDialogVisible = ref(false)

  // getters
  const showStoreList = computed(() => {
    return showList.value
  })

  const showMap = computed(() => {
    return resultsView.value === 'list-map' || resultsView.value === 'map'
  })

  // actions
  function toggleResultsView() {
    if (smallViewport.value) {
      resultsView.value = resultsView.value === 'list' ? 'map' : 'list'
    } else {
      resultsView.value = resultsView.value === 'list-map' || resultsView.value === 'list' ? 'map' : 'list-map'
    }
    showList.value = resultsView.value !== 'map'
  }

  function showListView() {
    resultsView.value = smallViewport.value ? 'list' : 'list-map'
    showList.value = true
  }

  function showMapView() {
    resultsView.value = 'map'
    showList.value = false
  }

  return {
    // state
    resultsView,
    showList,
    showResultsAsMapMoves,
    searchAndFilterOptionsDialogVisible,

    // getters
    showStoreList,
    showMap,

    // actions
    showMapView,
    showListView,
    toggleResultsView
  }
})

// adds HMR for pinia
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUiStore, import.meta.hot))
}
